export class SlerpError extends Error {}

class SlerpSpaceError extends SlerpError {}
export class TokenError extends SlerpError {}
export class UniquenessContraintError extends SlerpSpaceError {}

export class ThirdPartyIntegrationError extends SlerpError {}
export class StripeIntegrationError extends ThirdPartyIntegrationError {}
